import GeoblockChecker from "./checker";
import { PlayerAhoyEvent } from "../../player_ahoy_event";
import { PlayerEnvironment } from "../../player_environment";

export default class Geoblock {
  constructor(options = {}) {
    this._data = options.data;
    this._blocker = options.blocker;
    this._uuid = options.uuid;
    this._tech = options.tech;
    this.setAhoyEventGlobalProperties();
  }

  get data() { return this._data }
  get uuid() { return this._uuid }
  get tech() { return this._tech }
  get blocker() { return this._blocker }

  runAndBlock() {
    let checkerPromise = GeoblockChecker.checkContent(this.data.geoblockUrl());

    checkerPromise.then((blocked) => {
      if(blocked) {
        this.showBlocker();
        this.sendEvent();
      }

      this.data.setGeoblocked(blocked);
    });

    return checkerPromise;
  }

  showBlocker() {
    this.tech?.el()?.addClass('vjs-error');
    this.blocker.showGeoblockMessage();
  }

  sendEvent() {
    PlayerAhoyEvent.sendGeoblock(this.data.type(), this.data.videoId(), this.uuid);
    PlayerAhoyEvent.sendBlocker(this.data.type().toLowerCase(), this.data.isPremier(), this.data.videoId(), 'geoblock');
  }

  setAhoyEventGlobalProperties() {
    let globalData = {
      page: PlayerEnvironment.locationHref(),
      videopremier: this.data.isPremier(),
      referrer: PlayerEnvironment.referrer(),
      is_preview: this.data.preview(),
      cdn: this.data.cdnName(),
      embed: this.data.embed() === 'true',
    };

    if (this.data.userIsPremier()) {
      globalData.user_type = 'premier';
    }

    if (this.data.isVideo()) {
      if (this.data.filmId() != 0) {
        globalData.film_id = this.data.filmId();
      }

      if (this.data.seasonId() != 0) {
        globalData.season_id = this.data.seasonId();
      }
    }
    PlayerAhoyEvent._globalAppendData = globalData;
  }
}
